export default __webpack_public_path__ + "static/media/search.21363610.svg";